export default __webpack_public_path__ + "static/intelligent-automation-1-c300b8cb1ea263911178c833004ba61e.png";